// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Fgn0r","title":"Header_title__6rFbl","left":"Header_left__111Yc","clinicName":"Header_clinicName__1Ijho"};